import { Component, EventEmitter, Input, Output } from '@angular/core';

import { StatCardStatusModel } from '../../shared/components/stat-card/typings/stat-card-status';

const BAND_STATUSES : { [ band : string ] : StatCardStatusModel } = {
  bad : 'danger',
  good: 'success',
  warn: 'warning'
};

// A stat card that can open another page (link) or notify its tab (clickable).
@Component({
  selector   : 'wor-intelligence-kpi-card',
  template: require('./intelligence.kpi-card.component.html')
})
export class KpiCardComponent {
  @Input() band      : string;
  @Input() caption   : string = '';
  @Input() clickable : boolean = false;
  @Input() delta     : number | null;
  @Input() invert    : boolean = false;
  @Input() label     : string = '';
  @Input() link      : string;
  @Input() loading   : boolean = false;
  @Input() value     : string = '';

  @Output() pressed = new EventEmitter<void>();

  press () : void {
    if ( this.clickable ) {
      this.pressed.emit();
    }
  }

  status () : StatCardStatusModel {
    return BAND_STATUSES[ this.band ] || '';
  }
}
